import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sliderWidget"}},[_c(VLayout,{attrs:{"mx-2":"","align-center":"","justify-space-between":"","row":""}},[_c('span',{domProps:{"textContent":_vm._s(_vm.timestamp_text)}}),_c(VFlex,{attrs:{"ml-2":""}},[_c('input',{attrs:{"id":_vm.name,"type":"range","min":"0","max":_vm.sliderMaxi},on:{"input":_vm.onValueChanged}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }